import { render, staticRenderFns } from "./OriginalDocumentsTabs.vue?vue&type=template&id=e6c6bffe&scoped=true"
import script from "./OriginalDocumentsTabs.vue?vue&type=script&lang=js"
export * from "./OriginalDocumentsTabs.vue?vue&type=script&lang=js"
import style0 from "./OriginalDocumentsTabs.vue?vue&type=style&index=0&id=e6c6bffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6bffe",
  null
  
)

export default component.exports